import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/lib/ThemeContext";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      onClick={toggleTheme}
      className={`relative p-2 rounded-lg transition-all duration-200 hover:scale-105 ${
        theme === "dark"
          ? "bg-zinc-800 text-amber-400 hover:bg-zinc-700"
          : "bg-violet-50 text-violet-600 hover:bg-violet-100"
      } ${className}`}
      data-testid="theme-toggle"
      title={theme === "dark" ? "Modo claro" : "Modo oscuro"}
    >
      {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
};
